import React, { useEffect } from 'react';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { MantineProvider } from '@mantine/core';
import { theme } from './theme';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppSelection from '@/pages/AppSelection/AppSelection';
import { RouteUtils } from '@bobex/react-core/routes/RouteUtils';
import './i18n';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { EasterEggs } from '@/components/EasterEggs/EasterEggs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/nl-be.js';
import '@mantine/tiptap/styles.css';
import '@mantine/schedule/styles.css';

import { DatesProvider } from '@mantine/dates';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { SidebarProvider } from '@/components/Sidebar/SidebarProvider';
import { useHeartbeat } from '@/hooks/useHeartbeat';
import { useHttpErrorNotifications } from '@/hooks/useHttpErrorNotifications';
import Login from '@/pages/Login/Login';
import AppLayout from '@/components/Layout/AppLayout';
import { protectedRoutes } from '@/configs/routes.config';
import AllRoutes from '@/routes/RoutesMatcher';

// Component that uses heartbeat inside Router context
function AppWithHeartbeat() {
  useHeartbeat();
  return null;
}

function AppWithErrorNotifications() {
  useHttpErrorNotifications();
  return null;
}

function App() {
  function displayContextInTabTitle() {
    const context = RouteUtils.getContext();
    document.title = context ? `BackOffice ${context.toUpperCase()}` : 'BackOffice';
  }

  function displayContextInFavicon() {
    const context = RouteUtils.getContext();
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (context && link) {
      link.href = `/favicon-${context}.svg`;
    }
  }

  useEffect(() => {
    displayContextInTabTitle();
    displayContextInFavicon();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <MantineProvider theme={theme}>
        <DatesProvider settings={{ locale: i18n.language }}>
          <AppWithErrorNotifications />
          <Notifications position={'top-right'}/>
          <ModalsProvider />
          <EasterEggs />
          <SidebarProvider>
            {RouteUtils.getContext() == null ? (
              <Router basename={'/backoffice'}>
                {/*<AppWithHeartbeat*/}
                <Routes>
                  <Route path="/" element={<AppSelection />} />
                </Routes>
              </Router>
            ) : (
              <Router basename={RouteUtils.getBasename()}>
                {/*<AppWithHeartbeat*/}
                <AllRoutes
                  loginPage={<Login />}
                  appLayout={AppLayout}
                  protectedRoutes={protectedRoutes}
                  authenticatedEntryPath={RouteUtils.redirectToHomePage()}
                />
              </Router>
            )}
          </SidebarProvider>
        </DatesProvider>
      </MantineProvider>
    </I18nextProvider>
  );
}

export default App;
